<template>
  <div class="flex flex-col flex-1 min-w-0 h-full">
    <div class="box-header">
      <div class="box-title"> {{ $tc('contact_us') }} </div>
      <div class="box-action">
        <MIcon name="headphone" size="2x" />
      </div>
    </div>
    <MDivider class="mt-1 my-4" />
    <div class="flex flex-col">
      <div v-if="branding.contactNumber" class="flex items-center flex-1 pb-2">
        <div class="icon-container mb-2">
          <MIcon name="phone" size="lg" />
        </div>
        <div
          class="item-name items-center text-ellipsis"
          :title="branding.contactNumber"
        >
          <a :href="`tel:${branding.contactNumber}`" class="ml-1">
            {{ branding.contactNumber }}
          </a>
        </div>
      </div>
      <div v-if="branding.email" class="flex items-center pb-2">
        <div class="icon-container">
          <MIcon name="envelope" size="lg" />
        </div>
        <div
          class="item-name items-center text-ellipsis"
          :title="branding.email"
        >
          <a :href="`mailto:${branding.email}`" class="ml-1">
            {{ branding.email }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BrandingComputed } from '@state/modules/branding'
export default {
  name: 'ContactUsCard',
  computed: {
    ...BrandingComputed,
  },
}
</script>

<style lang="less" scoped>
.box-header {
  @apply flex justify-between items-center min-w-0;

  & .box-title {
    @apply flex pb-1;

    font-size: 0.898rem;
    font-weight: 500;
    color: var(--primary-alt);
  }

  & .box-action {
    color: var(--primary);
  }
}

.icon-container {
  color: var(--primary-alt);
}

.item-name {
  @apply px-1;

  a {
    color: var(--text-color);
  }
}
</style>
